import React from "react";
import { FormatMessage } from "react-globalize";
import { Link } from "react-router";

const MENU_OPTIONS = [
  "privacy",
  "terms",
  "esign",
  "agreement",
  "complaint",
  "notices"
]

export default function QuisqueyanaPolicyMenu(props)
{
  const conditionalLink = (areWrapped, optionName, children) => {
    return areWrapped ? 
      <Link to={"/quisqueyana" + optionName} 
      role="button" 
      aria-haspopup="true" 
      data-toggle="collapse"
      data-target= ".in" >
        {children}
      </Link>
    : children
  }

  return (
    <nav className="navbar navbar-default navbar-fixed-top">
      <div className="container-fluid">
        <div className="navbar-header">
          <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
            <span className="sr-only">Menu</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>          
          <button id="languageButton" onClick={() => {props.switchLanguage();}} >
              <i className="fa fa-globe fa-lg"></i>
                  {props.locale == "es" ? "EN" : "ES"}
          </button>
          <button type="button" className="btn navbar-btn" onClick={() => {props.switchExpand();}} onClickCapture={(e) => {
            $('.container .collapsebleDiv').collapse((props.expandAll ? "show" : "hide")  ); 
            $('.container .collapse').collapse((props.expandAll ? "show" : "hide")  ); 
            $('nav .navbar-collapse').collapse('hide'); }}> 
            <i className={"fa " + (props.expandAll ? "fa-caret-down" : "fa-caret-up") + " fa-lg"}></i>
          </button>
        </div>

        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">{
            MENU_OPTIONS.map(optionName => <li key={"menuOption" + optionName} className="col-sm-2">
              {conditionalLink(props.section !== optionName, optionName, <FormatMessage locale={props.locale} path={"quisqueyanaPolicy/" + optionName + "/title"} />)}
            </li>)
            }
          </ul>
        </div>
      </div>
    </nav>
  )
}



// WEBPACK FOOTER //
// ./js/SectionQuisqueyanaPolicy/QuisqueyanaPolicyMenu/QuisqueyanaPolicyMenu.js